export default __webpack_public_path__ + "static/media/BOB_0061.e817f2f9.JPG";